import { WappParentType } from 'weblite-web-wapprunner'
import {
  WAPP_COMMUNICATE_CORE_INITIALIZE_STACK_DATA,
  WAPP_COMMUNICATE_CORE_STACK_POP,
  WAPP_COMMUNICATE_CORE_STACK_PUSH,
  wappCommunicateCoreInitializeStackData,
} from '@weblite/wapp-communication-action/core'
import { WappMode } from '@weblite-wapps/protocol'
import { getWapp } from '$logic/wapps/service'
import { getWis } from '$logic/wises'
import { WappPanel } from '$logic/wapp-panels'
import { sendOldActionToWapp } from '$logic/wapp-communication/wapp-communication.publish'
import { wappSub } from '$func/subscription'

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_STACK_PUSH,
  async ({ payload: { snapShot, wappId, wisId, mode, input }, meta }) => {
    // if (parentMode !== 'main' && parentMode !== 'fullscreen') return
    // if (mode !== 'main' && mode !== 'fullscreen') return

    const { mode: parentMode } = meta

    if (parentMode !== WappMode.MAIN) return

    const wapp = await getWapp(wappId)
    if (!wapp) return

    if (wisId) {
      const wis = await getWis(wisId)
      if (!wis) return
    }

    // if (!wappHasMode({ wappId, mode })) return

    await WappPanel.openWapp(
      {
        wappId,
        wisId,
        input,
        hideHeader: true,
        parent: { type: WappParentType.WAPP, ...meta },
      },
      false,
      snapShot,
    )
  },
  true,
)

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_STACK_POP,
  ({ payload: output, meta }) => {
    const { mode } = meta
    if (mode !== WappMode.MAIN) return
    // if (mode !== 'main' && mode !== 'fullscreen') return

    WappPanel.closeTopWapp(output)
  },
  true,
)

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_INITIALIZE_STACK_DATA,
  ({ meta }) => {
    if (meta.mode !== WappMode.MAIN) {
      sendOldActionToWapp(
        wappCommunicateCoreInitializeStackData({
          snapshot: undefined,
          input: {},
        }),
        meta,
      )

      return
    }

    const { snapshot, childOutput } = WappPanel.getTopWappMeta() || {}
    sendOldActionToWapp(
      wappCommunicateCoreInitializeStackData({
        snapShot: snapshot,
        input: childOutput,
      }),
      meta,
    )
  },
  true,
)
